const Visa = (): JSX.Element => {
  return (
    <svg width="51" height="25" viewBox="0 0 51 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.892578" width="50" height="25" rx="4" fill="#00579F" />
      <path d="M22.2841 16.7529H19.457L21.2253 8.7804H24.0523L22.2841 16.7529Z" fill="white" />
      <path
        d="M32.5316 8.97541C31.974 8.8141 31.0895 8.63599 29.9959 8.63599C27.204 8.63599 25.238 9.72155 25.226 11.2736C25.2028 12.4187 26.6336 13.0547 27.7037 13.4365C28.7975 13.8266 29.1693 14.0813 29.1693 14.429C29.1581 14.9631 28.2854 15.2093 27.4715 15.2093C26.3428 15.2093 25.738 15.0824 24.8189 14.7852L24.4466 14.6579L24.051 16.4475C24.7141 16.6678 25.9357 16.8632 27.204 16.8718C30.1704 16.8718 32.1017 15.8031 32.1245 14.1491C32.1358 13.2416 31.3803 12.5461 29.7515 11.9779C28.7627 11.6131 28.1571 11.3671 28.1571 10.9939C28.1687 10.6546 28.6693 10.3071 29.7855 10.3071C30.7046 10.29 31.3798 10.4511 31.8914 10.6123L32.1471 10.697L32.5316 8.97541Z"
        fill="white"
      />
      <path
        d="M36.2905 13.9285C36.5233 13.4705 37.4192 11.6979 37.4192 11.6979C37.4075 11.7149 37.6516 11.2314 37.7912 10.9346L37.9888 11.6216C37.9888 11.6216 38.5241 13.5299 38.6404 13.9285C38.1985 13.9285 36.8489 13.9285 36.2905 13.9285ZM39.7802 8.7804H37.5935C36.9191 8.7804 36.4068 8.92446 36.1158 9.44188L31.9165 16.7528H34.8829C34.8829 16.7528 35.3713 15.7688 35.4763 15.5569C35.8017 15.5569 38.6874 15.5569 39.106 15.5569C39.1872 15.8368 39.4434 16.7528 39.4434 16.7528H42.061L39.7802 8.7804Z"
        fill="white"
      />
      <path
        d="M17.0954 8.7804L14.3267 14.2169L14.0242 13.1143C13.5123 11.8421 11.9069 10.4598 10.1155 9.77251L12.6515 16.7444H15.6411L20.0848 8.7804H17.0954Z"
        fill="white"
      />
      <path
        d="M11.7557 8.7804H7.20718L7.16064 8.94148C10.7088 9.60308 13.0587 11.1978 14.0241 13.1146L13.0353 9.45056C12.8725 8.94137 12.3723 8.79719 11.7557 8.7804Z"
        fill="#FAA61A"
      />
    </svg>
  );
};

export default Visa;
